import { getLatestState, updateState } from '../gameState'

const screenShake = (canvas: HTMLCanvasElement) => {
	let { screenShakeIntensity } = getLatestState()

	// apply screen shake to canvas
	if (canvas && screenShakeIntensity > 0) {
		canvas.style.transform = `translate(${(Math.random() - 0.5) * screenShakeIntensity}px, ${Math.random() * screenShakeIntensity}px)`
	}
	screenShakeIntensity *= 0.95
	if (screenShakeIntensity < 0.1) screenShakeIntensity = 0

	updateState({ screenShakeIntensity })
}

export default screenShake
